import { z } from 'zod';

export const OpenDaysSchema = z.object({
    address: z.string(),
    date: z.coerce.date(),
    startTime: z.string().nullable(),
    endTime: z.string().nullable(),
});
export type OpenDaysDTO = z.infer<typeof OpenDaysSchema>;
